import React, { useState, useContext, useEffect } from "react";
import { useSelector } from "react-redux";
import { makeStyles } from "@material-ui/styles";
import classNames from "classnames";
import { Button } from "@mantine/core";
import { UserManagerContext } from "../Context/userManagerContext";
import { Busy } from "../Common/UIComponents";
import { handleError } from "../AppCommon/util";

const useStyles = makeStyles((theme) => ({
  login: {
    alignItems: "center",
    display: "flex",
    padding: "0 5px",
  },
  button: {
    color: theme.app.labelColor,
    marginRight: "0.5rem",
  },
}));

const Login = () => {
  const classes = useStyles();
  const [busy, setBusy] = useState(false);
  const { userManager } = useContext(UserManagerContext);
  const { language, auth } = useSelector((state) => ({
    auth: state.oidc.user !== null && !state.oidc.user.expired,
    language: state.language,
  }));

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const redirect = searchParams.get("redirect");
    if (busy) {
      userManager.clearStaleState();
      userManager.signinRedirect().catch(handleError);
    } else if (redirect && !auth) {
      userManager.clearStaleState();
      userManager.signinRedirect().catch(handleError);
    }
  }, [busy, userManager]);

  return (
    <>
      {busy ? (
        <Busy text="Väntar på inloggning" />
      ) : (
        <div className={classes.login}>
          {auth ? (
            ""
          ) : (
            <Button
              onClick={() => setBusy(true)}
              className={classNames(
                classes.button,
                "login__login-button primaryButton"
              )}
              aria-label={language.login}
            >
              {language.login}
            </Button>
          )}
        </div>
      )}
    </>
  );
};

export default Login;
